import { useTranslation } from 'react-i18next';
import { Modal, FeaturedIcon } from '@unified-checkout/design-system';
import { CircleExclamation } from '@unified-checkout/design-system/icons/index';
import { useScreenWidth } from '@app/dashboard/hooks/useScreenWidth';
import { MOBILE_BREAKPOINT } from '@app/dashboard/constants/break-points';

export interface DeactivateConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isBranch?: boolean;
  isLoading?: boolean;
}

export const DeactivateConfirmModal = ({
  open,
  onClose,
  onConfirm,
  isBranch = false,
  isLoading = false,
}: DeactivateConfirmModalProps) => {
  const { t } = useTranslation();
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= MOBILE_BREAKPOINT;

  const title = isBranch
    ? t('innerLayout.paymePage.deactivateConfirm.branch.title')
    : t('innerLayout.paymePage.deactivateConfirm.payme.title');

  const subtitle = isBranch
    ? t('innerLayout.paymePage.deactivateConfirm.branch.subtitle')
    : t('innerLayout.paymePage.deactivateConfirm.payme.subtitle');

  const confirmButtonText = isBranch
    ? isMobile
      ? t('innerLayout.paymePage.deactivateConfirm.branch.confirmButtonMobile')
      : t('innerLayout.paymePage.deactivateConfirm.branch.confirmButton')
    : isMobile
    ? t('innerLayout.paymePage.deactivateConfirm.payme.confirmButtonMobile')
    : t('innerLayout.paymePage.deactivateConfirm.payme.confirmButton');

  return (
    <Modal
      open={open}
      onCloseHandler={onClose}
      hasCloseIcon={true}
      width="32rem"
      state="default"
      headerIcon={
        <FeaturedIcon icon={CircleExclamation} size="xl" color="red" />
      }
      keepHeaderIconDefaultColors={true}
      isOverlayAboveModal={true}
      title={title}
      supportingText={subtitle}
      btnsProps={[
        {
          text: confirmButtonText,
          variant: 'contained',
          color: 'danger',
          onClickHandler: onConfirm,
          disabled: isLoading,
          loading: isLoading,
        },
        {
          text: t('form.cancel'),
          variant: 'outlined',
          color: 'secondary',
          onClickHandler: onClose,
          disabled: isLoading,
        },
      ]}
    />
  );
};
